import Group from './group';
import MiniLineChart from './miniLineChart';
import MixLineBarChart from './mixLineBarChart';
import { TimeRangePicker } from './timeRangePicker';
const Chart = {
  MixLineBarChart,
  MiniLineChart,
  Group,
  TimeRangePicker
};
export default Chart;
export * from './hooks';
export * from './share';
export * from './interface';